"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Container = styled_components_1.default.section `
  display: flex;
  flex-direction: column;

  & > label {
    margin-bottom: 7px;
  }
`;
